var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.32,
    height: 21.725,
    viewBox: "0 0 90.32 21.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(-153.7 -13.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 90.32,
    height: 6.451,
    transform: "translate(153.7 27.36)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M12.8-2.982V-6.173h-7.2V-20.01H1.98V-2.982Zm13.837,0V-15.313H23.4v8.348a3.629,3.629,0,0,1-2.808,1.4,1.982,1.982,0,0,1-2.272-2.272v-7.48H15.076v8.756c0,2.4,1.276,3.88,3.983,3.88A5.771,5.771,0,0,0,23.4-4.539v1.557ZM28.786-4.59A8.3,8.3,0,0,0,34.3-2.676c3.421,0,5.336-1.685,5.336-3.957,0-3.063-2.834-3.625-4.953-4.034-1.379-.281-2.349-.562-2.349-1.328,0-.715.766-1.149,1.94-1.149a5.2,5.2,0,0,1,3.651,1.43L39.2-13.934a7.748,7.748,0,0,0-4.953-1.685c-3.242,0-5.055,1.813-5.055,3.88,0,2.936,2.732,3.446,4.851,3.855,1.4.281,2.476.587,2.476,1.455,0,.766-.664,1.251-2.068,1.251A7.058,7.058,0,0,1,30.19-6.863ZM46.171-2.676a4,4,0,0,0,2.706-.791l-.689-2.451a1.771,1.771,0,0,1-1.123.357c-.715,0-1.123-.587-1.123-1.353v-5.565h2.5v-2.834h-2.5v-3.37H42.673v3.37H40.631v2.834h2.042v6.433C42.673-3.85,43.9-2.676,46.171-2.676Zm7.735-.306v-8.144A4.109,4.109,0,0,1,56.944-12.5a4.306,4.306,0,0,1,.894.077v-3.166a5.275,5.275,0,0,0-3.931,1.966v-1.685H50.664V-2.982Zm16.594,0v-7.965c0-3.549-2.578-4.672-5.387-4.672a8.089,8.089,0,0,0-5.387,1.94l1.225,2.17a5.188,5.188,0,0,1,3.6-1.455c1.634,0,2.706.817,2.706,2.068v1.71a4.984,4.984,0,0,0-3.906-1.506c-1.966,0-4.289,1.047-4.289,3.931a4.108,4.108,0,0,0,4.289,4.085,5.1,5.1,0,0,0,3.906-1.583v1.276ZM67.258-5.943a3.243,3.243,0,0,1-2.6,1.072c-1.276,0-2.323-.664-2.323-1.813,0-1.174,1.047-1.864,2.323-1.864a3.243,3.243,0,0,1,2.6,1.072Zm9.7,1.379a4.711,4.711,0,0,0,3.8,1.889c3.166,0,5.463-2.374,5.463-6.484s-2.3-6.459-5.463-6.459a4.763,4.763,0,0,0-3.8,1.864v-1.557H73.717V1.715h3.242Zm5.9-4.6c0,2.144-1.251,3.6-3.115,3.6a3.713,3.713,0,0,1-2.783-1.4V-11.33a3.631,3.631,0,0,1,2.783-1.4C81.605-12.734,82.856-11.279,82.856-9.16Z",
    transform: "translate(154.282 34)",
    fill: "#fefefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.43b4cb48ee3ea19608867776640dcf14.svg";
export { ForwardRef as ReactComponent };